import React from 'react';
import { Route, useLocation } from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import {
  AccessToConnectorApollo,
  callNativeMobileApp,
  useTranslator,
} from '@front-activerse/common-components';
import UnauthorizedException from '../Unauthorized/UnauthorizedException';
import UniversalPlaceholder from '../Layout/UniversalPlaceholder';
import { useAppContext } from '@front-activerse/common-components';
import { IRoute } from '@front-activerse/common-components';

interface ICookbookPage {
  descendantRoutes: IRoute[];
  cookbookNavigation: {
    path: string;
    translationKey: string;
  }[];
}

const CookbookPage: React.FC<ICookbookPage> = ({ descendantRoutes, cookbookNavigation }) => {
  const location = useLocation();

  const { t } = useTranslator();

  const {
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();

  return (
    <AccessToConnectorApollo>
      {({ authorized, loading }) => {
        if (!loading && !authorized && location.pathname !== '/meals/cookbook') {
          callNativeMobileApp({
            action: 'title_changed',
            payload: {
              title: t('meals.navbarTitle'),
            },
          });

          return <UnauthorizedException mealPlanNavigation={cookbookNavigation} />;
        }

        return loading ? (
          <UniversalPlaceholder />
        ) : (
          <SlideRoutes duration={+SLIDE_ROUTES_DURATION} animation="slide" destroy={false}>
            {descendantRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}
          </SlideRoutes>
        );
      }}
    </AccessToConnectorApollo>
  );
};

export default CookbookPage;
